import { Injectable, TemplateRef } from '@angular/core';

interface ToastOptions {
    type?: string,
    delay?: number
}

@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: any[] = [];

    show(textOrTpl: string | TemplateRef<any>, options: ToastOptions = {}) {
        this.toasts.push({ textOrTpl, ...options });
    }

    warn(textOrTpl: string) {
        this.show(textOrTpl, { type: 'warn' })
    }

    remove(toast) {
        this.toasts = this.toasts.filter(t => t !== toast);
    }

}